<!-- Dialog.vue -->
<template>
  <!-- Dialog Template -->
  <!-- Dialog Component Vuetify -->
  <v-dialog
    content-class="dialog-container customDialog"
    scrollable
    persistent
    v-model="modalOpen"
    :width="screenWidth < 770 ? '100%' : width"
    @keydown.esc="closeDialog"
  >
    <v-card tile class="h-100" :data-test-id="dataTestId">
      <!-- title for the dialog -->
      <v-card-title class="pa-8">
        {{ dialogTitle }}
        <v-btn
          text
          icon
          class="close-icon"
          :data-test-id="`${dataTestId}__close-icon`"
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Text for the dialog -->
      <v-card-text flat class="pt-10" v-if="confirmDialog">
        <p class="collab-text">{{ dialogText || confirmDialogDefaultText }}</p>
      </v-card-text>
      <v-card-text class="px-10" v-else>
        <slot name="dialog_data"></slot>
      </v-card-text>
      <!-- Action buttons -->
      <v-card-actions class="px-10 py-7" v-if="actions.show">
        <v-row no-gutters justify="space-between">
          <x-button
            v-if="actions.showTertiary"
            :color="colors && colors.red"
            @click="actions.tertiaryButtonFunction"
            :buttonText="actions.tertiaryButtonText"
            :data-test-id="`${dataTestId}__tertiary-btn`"
          />
          <v-row no-gutters justify="end">
            <x-button
              outline
              :color="colors && colors.primary"
              @click="actions.secondaryButtonFunction"
              :buttonText="actions.secondaryButtonText"
              :data-test-id="`${dataTestId}__secondary-btn`"
            />
            <x-button
              :color="colors && colors.primary"
              @click="actions.primaryButtonFunction"
              :buttonText="actions.primaryButtonText"
              class="ml-3 white--text"
              v-if="actions.primaryButtonShow"
              :disabled="actions.primaryButtonDisabled"
              :data-test-id="`${dataTestId}__primary-btn`"
            />
          </v-row>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  /**
   * @dialogTitle title for dialog
   * @dialogState for modal state
   * @dialogText for dialog text
   * @width of modal
   * @confirmDialog checks if confirm dialog
   * @actions is a object to show action button as of now it supports only two
   * @param show property tp show action buttons
   * @param text can be added for both buttons, @param function can be added for both buttons,
   * @param check can be added for button buttons
   */
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
    colors() {
      return this.$vuetify?.theme?.themes?.light;
    }
  },
  props: {
    hasFixedHeader: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Object,
      default: function() {
        return {
          secondaryButtonShow: true,
          primaryButtonShow: true,
          primaryButtonDisabled: false
        };
      }
    },
    dialogTitle: String,
    dialogState: Boolean,
    dialogText: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '50%'
    },
    confirmDialog: {
      type: Boolean,
      default: false
    },
    dataTestId: String
  },
  data() {
    return {
      modalOpen: false,
      confirmDialogDefaultText: 'This action is irreversible. Are you sure?'
    };
  },
  methods: {
    closeDialog() {
      this.modalOpen = false;
      this.$emit('toggleModal', false);
    }
  },
  watch: {
    dialogState: function() {
      this.modalOpen = this.dialogState;
    }
  }
};
</script>
